
<div v-if="entity">
  <EntityShowHeader :entity="entity" />
  <b-row class="qb-container">
    <b-col xl="6">
      <Card
        data-testid="card-entity-details"
        icon="briefcase"
        :label="__('entities.details')"
      >
        <template #actions>
          <div class="btn-group-sm">
            <b-button
              v-can:entities.update
              size="md"
              variant="primary"
              class="mr-2"
              data-testid="entity-edit-btn"
              @click="handleEdit"
            >
              <Icon icon="edit" size="14" class="mr-2" />
              {{ __('buttons.edit') }}
            </b-button>

            <b-button
              v-if="['pending', 'inactive'].includes(entity.status)"
              v-can:entities.update
              size="md"
              variant="outline-success"
              data-testid="entity-activate-btn"
              @click="activate"
            >
              <Icon icon="check" size="14" class="mr-2" />
              {{ __('buttons.activate') }}
            </b-button>

            <b-button
              v-if="entity.status === 'active'"
              v-can:entities.update
              size="md"
              variant="outline-danger"
              data-testid="entity-deactivate-btn"
              @click="deactivate"
            >
              <Icon icon="times" size="14" class="mr-2" />
              {{ __('buttons.deactivate') }}
            </b-button>
          </div>
        </template>

        <DataGroup>
          <DataGroupItem :label="__('common.name')" :value="entity.name" />
          <DataGroupItem
            v-if="entity.network"
            label="Network"
            :value="entity.network"
          />
          <DataGroupItem
            :label="__('common.reference')"
            :value="entity.code"
          />
          <DataGroupItem :label="__('common.tag')" :value="entity.tag" />
          <DataGroupItem
            :label="__('common.legal-name')"
            :value="entity.legalName"
          />
          <DataGroupItem
            :label="__('address.address')"
            :value="entity.address"
          />
          <DataGroupItem :label="__('entities.toba')" :value="toba" />

          <DataGroupItem
            v-if="entity.parentId"
            :label="__('entities.parent-entity')"
          >
            <RouterLink
              v-if="entity.parent"
              :to="{
                name: 'entities.show',
                params: { entityId: entity.parentId },
              }"
            >
              {{ entity.parent.name }}
            </RouterLink>
          </DataGroupItem>
        </DataGroup>
      </Card>
    </b-col>

    <b-col xl="6">
      <b-row>
        <b-col cols="12">
          <Card
            data-testid="card-entity-financials"
            icon="coins"
            :label="__('entities.financials')"
          >
            <DataGroup>
              <DataGroupItem
                :label="__('entities.bank-details')"
                :value="entity.bankDetails"
              />
              <DataGroupItem
                :label="__('entities.is-payment')"
                :value="
                  entity.isMakingPayments ? __('common.yes') : __('common.no')
                "
              />
              <DataGroupItem
                :label="__('entities.is-automated-statement')"
                :value="
                  entity.isAutomatedStatement
                    ? __('common.yes')
                    : __('common.no')
                "
              />
              <DataGroupItem
                v-if="entity.paymentTerm"
                :label="__('menu.payment-terms')"
                :value="entity.paymentTerm.name"
              />
            </DataGroup>
          </Card>
        </b-col>
        <b-col lg="12">
          <ModelDataCard
            v-can:entities.data.view
            :data="entity.data"
            :open-edit-modal="openEditDataModal"
            :update-permission="$can('entities.data.update')"
          />
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="6">
      <Card icon="comment" :label="__('common.notes')">
        {{ entity.notes }}
      </Card>
    </b-col>
    <b-col cols="6">
      <Card icon="upload" :label="__('entities.logo')">
        <template #actions>
          <div class="btn-group-sm">
            <b-button
              v-can:entities.update
              size="md"
              variant="primary"
              class="mr-2"
              @click="openUploadLogoModal"
            >
              <Icon icon="upload" size="14" class="mr-2" />
              {{ __('entities.upload-logo') }}
            </b-button>
          </div>
        </template>
        <div v-if="logoUrl" class="text-center">
          <img :src="logoUrl" alt="Logo" class="img-fluid" />
        </div>
      </Card>
    </b-col>

    <b-col v-if="entity.isGroup" cols="12">
      <Card icon="cube" :label="__('entities.subsidiaries')" table>
        <template #actions>
          <b-button
            v-can:entities.create
            size="md"
            variant="outline-primary"
            data-testid="create-subsidiary-btn"
            @click="handleCreateSubsidiary"
          >
            <Icon icon="plus-circle" size="14" class="mr-2" />
            {{ __('entities.create-subsidiary') }}
          </b-button>
        </template>
        <div class="table-responsive">
          <table class="table table-sm table-nowrap card-table table-hover">
            <thead>
              <tr>
                <th>{{ __('common.name') }}</th>
                <th>{{ __('common.type') }}</th>
                <th>{{ __('common.code') }}</th>
                <th>{{ __('common.legal-name') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(child, key) in entity.children" :key="key">
                <td>
                  <RouterLink
                    :to="{
                      name: 'entities.show',
                      params: { entityId: child.id },
                    }"
                  >
                    {{ child.name }}
                  </RouterLink>
                </td>
                <td>
                  <Badge :variant="child.typeData().badge">
                    {{ child.typeData().label }}
                  </Badge>
                </td>
                <td>
                  {{ child.code }}
                </td>
                <td>
                  {{ child.legalName }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>
    </b-col>
  </b-row>
</div>
